module.exports = __webpack_public_path__ + "static/assets/64f522dd3cf4448688b66c267336b88f.svg";